// Location service area boundaries
// Updated to include all approved delivery locations in Panipat
export const PANIPAT_BOUNDS = {
  minLat: 29.30,   // Lowest latitude: 29.3101°N
  maxLat: 29.46,   // Highest latitude: 29.44097°N
  minLng: 76.88,   // Lowest longitude: 76.8980°E
  maxLng: 77.13    // Highest longitude: 77.1162°E
};

// Panipat center coordinates for map initialization
export const PANIPAT_CENTER = {
  lat: 29.38,
  lng: 76.97
};

// Search configuration
export const SEARCH_CONFIG = {
  debounceTime: 400, // milliseconds
  resultLimit: 10,
  minQueryLength: 3
};

// Free delivery radius in kilometers
export const FREE_DELIVERY_RADIUS_KM = 5;

// Delivery price center reference
export const DELIVERY_CENTER = { lat: 29.3855, lng: 76.9703 };
export const MAX_DELIVERY_RADIUS_KM = 15;
